import { FacilityStatus } from '../facilities/facility.model';
import { CorporateLocationDto } from '../corporate-location/corporate-location.dto';

export interface CorporationDto {
  id: string; // Guid
  name: string;
  description?: string | null;
  email: string;
  phone?: string | null;
  website?: string | null;
  logoUrl?: string | null;
  address?: string | null;
  addressLine1?: string | null;
  addressLine2?: string | null;
  city?: string | null;
  state?: string | null;
  postalCode?: string | null;
  country?: string | null;
  timeZone?: string | null;
  businessHours?: string | null;
  isActive: boolean;
  createdAt: string; // DateTime as ISO string
  updatedAt?: string | null; // DateTime as ISO string
  locations?: CorporateLocationDto[] | null;
  status: FacilityStatus;
  zipCode?: string | null;
}
